module.exports = "<div style=\"position: relative;\">\n  <v-layout v-if=\"isLoading\" align-center justify-center style=\"position: absolute; top:0; left:0; right: 0; bottom: 0; z-index: 200; background: rgba(255, 255, 255, .95)\">\n    <!-- // =========== spinner -->\n    <div class=\"primary--text\">\n      <div class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>\n      <div>Patientez SVP ...</div>\n    </div>\n  </v-layout>\n  <div id=\"calendar\" />\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agenda/components/agenda-calendar/template.html
// module id = ls5g
// module chunks = 0